import styled, { css } from "styled-components"
import { displays } from "theme/base/Variables"

export interface IScannerInputStyled {
  expand: boolean
  variant?: "primary" | "secondary"
  isActive?: boolean
  isBarcodeMode?: boolean
}

const ScannerInputStyled = styled.section<IScannerInputStyled>`
  width: 100%;
  ${displays.flexCenter};
  border-radius: 8px;
  border: 1px solid transparent;
  transition: background 0.3s ease;

  ${({ variant, isActive, theme }) => {
    if (variant === "secondary") {
      return css`
        background: ${isActive ? "#EAB30A" : "#28AE60"};
        & .btn-scanner-text {
          background: ${isActive ? "#fff" : "#28AE60"} !important;
          border-color: ${isActive ? "#fff" : "#28AE60"} !important;
          color: ${isActive ? "#EAB30A" : "#fff"} !important;
        }
        & .scanner-text {
          color: #fff !important;
        }
        & .scanner-text::placeholder {
          color: #fff !important;
        }
      `
    }
  }}

  & .btn-scanner-text {
    padding: 1rem;
    color: ${({ theme }) => theme.palette.white};
    background: ${({ theme }) => theme.palette.grey60};
    transition: 0.4s;
    cursor: pointer;
    z-index: 10;
    width: 100%;
    position: relative;

    & svg {
      font-size: 2rem;
    }
  }

  & .scanner-text {
    border: none;
    background: none;
    outline: none;
    padding: 0;
    color: ${({ theme }) => theme.palette.white};
    transition: 0.4s;
    line-height: 40px;
    width: 0;
    text-align: left;
  }

  ${({ expand, variant, isBarcodeMode }) => {
    if (expand) {
      return css`
        background: ${variant === "secondary" ? "" : ({ theme }: any) => theme.palette.grey60};
        gap: 0.5rem;

        & .scanner-text {
          padding: 0 0.5rem;
          width: 100%;
          ${isBarcodeMode && css`
            position: absolute;
            opacity: 0;
            width: 0;
            height: 0;
            padding: 0;
            pointer-events: none;
          `}
        }

        & .btn-scanner-text {
          background: ${variant === "secondary" ? "#fff" : ({ theme }: any) => theme.palette.white};
          color: ${variant === "secondary" ? "#EAB30A" : ({ theme }: any) => theme.palette.grey80};
          width: ${isBarcodeMode ? "100%" : "unset"};
          border: 1px solid #ffffff;
          border-radius: 8px;
          ${isBarcodeMode && css`
            cursor: default;
            justify-content: center;
          `}
        }
      `
    }
  }}
`

export default ScannerInputStyled
